import { render, staticRenderFns } from "./FeedbackManagement.vue?vue&type=template&id=098cc6a7&scoped=true"
import script from "./FeedbackManagement.vue?vue&type=script&lang=js"
export * from "./FeedbackManagement.vue?vue&type=script&lang=js"
import style0 from "./FeedbackManagement.vue?vue&type=style&index=0&id=098cc6a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098cc6a7",
  null
  
)

export default component.exports